<template>
  <div
    class="data-board-s"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
    }"
    ref="dataBoardS"
  >
    <div class="title">
      <div>
        <eui-icon icon="eicon-xsbb" color="#333" font-size="18px" />
        <span class="text">销售报表</span>
      </div>
      <div class="more" @click="goPath" v-if="isMore">
        查看更多
        <!-- <eui-icon style="margin: 0;" icon="eicon-arrow-right" font-size="12px" /> -->
        <span class="el-icon-arrow-right"></span>
      </div>
    </div>
    <div class="">
      <!-- 数据 -->
      <div class="data-header-box">
        <div class="data-header-li">
          <div class="data-li-top">商品情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.allProductCount }}</span>
                <span>种</span>
              </div>
              <div class="text-p">在线商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.orderProductCount }}</span>
                <span>种</span>
              </div>
              <div class="text-p">成交商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.yearProductCount }}</span>
                <span>种</span>
              </div>
              <div class="text-p">本年上线商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.effectiveOrderProductCount }}</span>
                <span>种</span>
              </div>
              <div class="text-p">本年成交商品</div>
            </div>
          </div>
        </div>
        <div class="data-header-li">
          <div class="data-li-top">销售情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.thisYearOrderAmount }}</span>
                <span>元</span>
              </div>
              <div class="text-p">本年度销售额</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.mom }}</span>
                <span>%</span>
              </div>
              <div class="text-p">
                <div>环比</div>
                <el-tooltip class="item" effect="dark" placement="bottom-start">
                  <div slot="content">
                    （本年度销售额 - 上年度销售额）/ 上年度销售额
                  </div>
                  <eui-icon icon="eicon-problem-press" color="#C5C5C5" font />
                </el-tooltip>
              </div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.industryRank }}</span>
                <span>%</span>
              </div>
              <div class="text-p">
                <div>超过同行业</div>
                <el-tooltip class="item" effect="dark" placement="bottom-start">
                  <div slot="content">
                    企业所在行业：{{ catalogueData.classificationName }}
                    <br />
                    在该会员所在行业内的公司、按照公司纬度分
                    <br />
                    组统计报告周期内未删除的、有效订单的销售
                    <br />
                    总金额，按照销售额升序排序，S%=排序序号
                    <br />
                    数 / (该行业有销售额的公司总数)
                  </div>
                  <eui-icon icon="eicon-problem-press" color="#C5C5C5" />
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="data-header-li">
          <div class="data-li-top">客户情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.thisYearCount }}</span>
                <span>家</span>
              </div>
              <div class="text-p">本年新增客户</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                <span class="number">{{ catalogueData.allCount }}</span>
                <span>家</span>
              </div>
              <div class="text-p">累计成交客户</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="databoard">
      <div class="chart1">
        <el-popover placement="bottom" :offset="-20" trigger="click" ref="popover">
          <div>
            <el-date-picker
              :clearable="false"
              @change="dateSet"
              class="datepicker"
              v-model="queryData.date"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
          <div class="date flex" slot="reference">
            <p>
              {{ getFormatDate() }}
              <i class="el-icon-arrow-down"></i>
            </p>
          </div>
        </el-popover>
        <div id="myChart-1"></div>
        <div class="table">
          <el-table
            size="mini"
            ref="tableData"
            class="scrollbar_content"
            tooltip-effect="dark"
            :header-cell-style="{
              background: '#f5f5f5',
              color: '#333333',
              height: '40px',
              fontSize: '14px',
              fontWeight: 400,
            }"
            :data="purchaseData"
            style="width: 100%"
            border
          >
            <!-- <el-table-column prop="date" label="询价企业" width="180" align="center"> </el-table-column> -->
            <el-table-column
              :fixed="tableFiexed(item.name)"
              min-width="90px"
              v-for="(item, index) in purchaseColumns"
              :key="index"
              :prop="item.createDate"
              :label="item.name"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateformate, getYearAndMonth } from '@/modules/projectA/utils/utils';
import api from '@/modules/projectA/api/dataCenter';
import Api from '@/modules/projectA/api/user/index';
import bus from '@/components/common/bus';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      minDate: null,
      maxDate: null,

      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            },
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: time => {
          const choiceDateTime = new Date(this.selectDate).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 11
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 11
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后12个月时间可选,后12个月最大为当前日期
          if (this.selectDate) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
      queryData: {
        date: [new Date().setMonth(new Date().getMonth() - 11), new Date().getTime()],
      },
      purchaseData: [],
      purchaseColumns: [],
      dataType: 1,
      chart2TableData: [],
      chart3Data: [],
      chart4Columns: [],
      chart4Data: [],
      dateList: [],

      catalogueData: {
        classificationName: '',
        allCount: 0, // 所有客户数量
        thisYearCount: 0, // 本年新增客户数量
        thisYearOrderAmount: 0, // 本年度销售额
        industryRank: 0, // 超过同行业
        mom: 0, // 环比
        yearProductCount: 0, // 本年上线商品
        orderProductCount: 0, //成交数量
        effectiveOrderProductCount: 0, // 本年成交商品数量
        allProductCount: 0, // 在线商品数量
      },

      myChart1: null,
      isMore: false,
      sellData: [],
      tableLabel: [
        { label: '年月', param: 'months', align: 'center' },
        { label: '销售金额', param: 'orderAmount', align: 'center' },
        { label: '订单数', param: 'orderCount', align: 'center', width: '200' },
      ],
    };
  },
  mounted() {
    this.initData();
    this.queryConsumerCore();
    this.querySaleCore();
    this.queryProductCore();
    this.getHasAuthCode();

    const mainChart = this.$refs.dataBoardS;
    const that = this;
    const elementResizeDetectorMaker = require('element-resize-detector');
    let erd = elementResizeDetectorMaker();
    erd.listenTo(mainChart, ele => {
      this.$nextTick(() => {
        that.myChart1 && that.myChart1.resize();
      });
    });
  },
  methods: {
    async getHasAuthCode() {
      const result = await api.hasAuthCode({ authCode: '/dataStatistics' });
      // console.log(result, '/dataStatistics');
      if (result.code === '200') {
        this.isMore = result.data;
      }
    },
    goPath() {
      this.$router.push({
        path: '/dataStatistics',
      });
    },
    // 查询供应商客户情况核心数据
    async queryConsumerCore() {
      let res = await Api.queryConsumerCore({});
      if (res.code == '200' && res.data.length) {
        this.catalogueData.allCount = res.data[0].allCount;
        this.catalogueData.thisYearCount = res.data[0].thisYearCount;
      }
    },
    // 查询供应商销售核心数据
    async querySaleCore() {
      let res = await Api.querySaleCore({});
      if (res.code == '200' && res.data) {
        this.catalogueData.industryRank = res.data.industryRank * 100 || 0;
        this.catalogueData.thisYearOrderAmount = res.data.thisYearOrderAmount || 0;
        this.catalogueData.mom = res.data.mom ? res.data.mom * 100 : 0;
        this.catalogueData.classificationName = res.data.classificationName || '';
      }
    },
    // 查询供应商商品情况核心数据
    async queryProductCore() {
      let res = await Api.queryProductCore({});
      if (res.code == '200' && res.data.length) {
        this.catalogueData.yearProductCount = res.data[0].yearProductCount;
        this.catalogueData.allProductCount = res.data[0].allProductCount;
        this.catalogueData.orderProductCount = res.data[0].orderProductCount;
        this.catalogueData.effectiveOrderProductCount = res.data[0].effectiveOrderProductCount;
      }
    },
    tableFiexed(name) {
      if (name == '年月') {
        return 'left';
      } else if (name == '合计') {
        return 'right';
      }
    },
    getFormatDate() {
      return (
        dateformate(this.queryData.date[0], 'yyyy年MM月') +
        '-' +
        dateformate(this.queryData.date[1], 'yyyy年MM月')
      );
    },
    dateSet() {
      this.$refs.popover.doClose();
      this.initData();
    },
    //初始化数据
    initData() {
      this.querySinochemOrderList();
      /* this.querySinochemOrderByDepartment();
      this.querySinochemOrderByCategory();
      this.querySinochemOrderBySupplier(); */
    },
    changeDataType(type) {
      this.dataType = type;
      this.querySinochemOrderList();
    },
    handleParams() {
      let year = dateformate(this.queryData.date[1], 'yyyy');
      let month = dateformate(this.queryData.date[1], 'M');
      let dateNum = new Date(year, month, 0).getDate();
      let list = getYearAndMonth(
        dateformate(this.queryData.date[0], 'yyyy-MM'),
        dateformate(this.queryData.date[1], 'yyyy-MM')
      );
      list.unshift(dateformate(this.queryData.date[0], 'yyyy-MM'));
      let arr = [];
      list.forEach(item => {
        let year = item.split('-')[0];
        let month = parseInt(item.split('-')[1]);
        item = year + '-' + month;
        arr.push(item);
      });
      this.dateList = arr;
      return {
        startTime: dateformate(this.queryData.date[0], 'yyyy-MM-1 00:00:00'),
        endTime: dateformate(this.queryData.date[1], `yyyy-MM-${dateNum} 00:00:00`),
      };
    },

    /* async querySinochemOrderList() {
      let params = this.handleParams();
      let res = await api.queryOrderDataByMonth(params);
      if (res.success) {
        let resultList = res.data ? res.data.supplierData : [];
        this.sellData = [...resultList];
        const orderCounts = resultList.map(item => item.orderCount);
        const orderAmounts = resultList.map(item => item.orderAmount);
        const months = resultList.map(item => item.months);

        tableLabel;

        this.echartsInit1(months, orderCounts, orderAmounts);

        columns.unshift({
          createDate: '年月',
          name: '年月',
          orderAmount: '销售金额',
          orderCount: '订单数',
        });
        columns.push({
          createDate: '合计',
          name: '合计',
          orderAmount: '销售金额',
          orderCount: '订单数',
        });

        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      }
    }, */

    async querySinochemOrderList() {
      let params = this.handleParams();
      let res = await api.queryOrderDataByMonth(params);
      if (res.success) {
        let resultList = res.data ? res.data.supplierData : [];
        resultList.forEach(item => {
          let year = Number(item.months.split('-')[0]);
          let month = Number(item.months.split('-')[1]);
          item.year = String(year);
          item.month = String(month);
          this.$set(item, 'createDate', item.year + '-' + item.month);
        });
        // console.log(resultList, 'resultListresultListresultList');
        this.purchaseData = [];
        let xArr = [];
        let yArr1 = [];
        let yArr2 = [];
        let columns = [];

        let obj1 = { 年月: '销售金额' };
        let obj2 = { 年月: '订单数' };
        let count1 = 0;
        let count2 = 0;
        let allData = [];
        this.dateList.map(item => {
          let obj = {
            createDate: item,
            month: item.split('-')[1],
            orderAmount: 0,
            orderCount: 0,
            year: item.split('-')[0],
          };
          resultList.forEach(list => {
            if (item == list.createDate) {
              obj = list;
            }
          });
          allData.push(obj);
        });

        allData.forEach(item => {
          let name = item.year.substr(2, 4) + '年' + item.month + '月';
          xArr.push(name);
          yArr1.push(item.orderAmount);
          yArr2.push(item.orderCount);
          columns.push({
            name: name,
            ...item,
          });

          obj1[item.createDate] = item.orderAmount;
          obj2[item.createDate] = item.orderCount;
          count1 = count1 + item.orderAmount;
          count2 = count2 + item.orderCount;
        });
        this.echartsInit1(xArr, yArr1, yArr2);

        columns.unshift({
          createDate: '年月',
          name: '年月',
          orderAmount: '销售金额',
          orderCount: '订单数',
        });
        columns.push({
          createDate: '合计',
          name: '合计',
          orderAmount: '销售金额',
          orderCount: '订单数',
        });
        obj1['合计'] = count1;
        obj2['合计'] = count2;
        this.purchaseData.push(obj1);
        this.purchaseData.push(obj2);
        this.purchaseColumns = columns;
        this.purchaseData.forEach(obj => {
          for (const item in obj) {
            if (typeof obj[item] == 'number') {
              if (obj[item] > 10000) {
                obj[item] = (Math.round((obj[item] / 10000) * 100) / 100).toFixed(2) + 'w';
              } else {
                obj[item] = obj[item];
              }
            }
          }
        });

        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      }
    },
    echartsInit1(xArr, yArr1, yArr2) {
      let yMax1 = Math.max(...yArr1);
      let yMin1 = Math.min(...yArr1);
      let yMax2 = Math.max(...yArr2);
      let yMin2 = Math.min(...yArr2);
      let interval1 = 1;
      let interval2 = 1;
      if (yArr1.length === 1) {
        interval1 = yMax1;
        interval2 = yMax2;
        yMin1 = 0;
        yMin2 = 0;
      } else {
        if (yMax1 - yMin1 > 0) {
          interval1 = (yMax1 - yMin1) / 5;
          // interval1 = interval1.toFixed(0);
        }
        if (yMax2 - yMin2 > 0) {
          interval2 = (yMax2 - yMin2) / 5;
          // interval2 = interval2.toFixed(0);
        }
      }
      // if (yMax1 - yMin1 > 0) {
      //   interval1 = (yMax1 - yMin1) / 5;
      // }
      // if (yMax2 - yMin2 > 0) {
      //   interval2 = (yMax2 - yMin2) / 5;
      // }
      // console.log(yMax1, yMin1, interval1, 'ss');
      // console.log(yMax2, yMin2, interval2, 'ss');
      this.$nextTick(() => {
        this.myChart1 = this.$echarts.init(document.getElementById('myChart-1'));
        this.myChart1.setOption({
          title: {
            text: '销售趋势',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [20, 0, 0, 20],
          },
          legend: {
            data: ['销售金额', '订单数'],
            top: 'bottom',
          },
          tooltip: {},
          xAxis: {
            data: xArr,
          },
          //直角坐标系内绘图网格
          grid: {
            top: '30%', //grid组件距上下左右的距离
            left: '3%',
            right: '3%',
            bottom: '10%',
            containLabel: true, //grid区域是否包含坐标轴的刻度标签。
          },

          yAxis: [
            {
              type: 'value',
              name: '销售金额',
              minInterval: 1,
              axisLabel: {
                formatter: function(value, index) {
                  if (value > 10000) {
                    value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
                  } else {
                    value = value.toFixed(1);
                  }
                  return value;
                },
              },
              min: yMin1,
              max: yMax1,
              splitNumber: 5,
              interval: interval1,
            },
            {
              type: 'value',
              name: '订单数',
              minInterval: 1,
              axisLabel: {
                formatter: function(value, index) {
                  return value.toFixed(1);
                },
              },
              min: yMin2,
              max: yMax2,
              splitNumber: 5,
              interval: interval2,
            },
          ],
          series: [
            {
              name: '销售金额',
              type: 'bar',
              data: yArr1,
              yAxisIndex: 0,
              barWidth: 18, //柱图宽度
              /* itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#32DAFF' },
                  { offset: 1, color: '#28B2FF' },
                ]),
              }, */
              itemStyle: {
                color: '#6AA1FF',
              },
            },
            {
              name: '订单数',
              itemStyle: {
                color: '#FAAC7B',
              },
              type: 'line',
              smooth: true,
              data: yArr2,
              yAxisIndex: 1,
            },
          ],
        });
        this.resize(this.myChart1);
      });
    },
    async querySinochemOrderByDepartment() {
      let params = this.handleParams();
      let res = await api.querySinochemOrderByDepartment(params);
      if (res.success) {
        let list1 = res.data || [];
        let yData1 = [];
        let barData1 = [];
        let tableData1 = [];
        list1.forEach(item => {
          yData1.push(item.departmentName);
          barData1.push(item.orderAmount);
          tableData1.push({
            name: item.departmentName,
            count: item.orderAmount,
          });
        });
        this.chart2TableData = tableData1;
        this.echartsInit2(yData1, barData1);
      }
    },
    async querySinochemOrderBySupplier() {
      let params = this.handleParams();
      let res = await api.querySinochemOrderBySupplier(params);
      if (res.success) {
        let list = res.data || [];
        let yData1 = [];
        let barData1 = [];
        let tableData1 = [];
        list.forEach(item => {
          yData1.push(item.supplierCompany);
          barData1.push(item.orderAmount);
          tableData1.push({
            name: item.supplierCompany,
            count: item.orderAmount,
          });
        });
        this.chart3Data = tableData1;
        this.echartsInit3(yData1, barData1);
      }
    },

    async querySinochemOrderByCategory() {
      let params = this.handleParams();
      let res = await api.querySinochemOrderByCategory(params);
      if (res.success) {
        let list = res.data ? res.data : [];
        this.chart4Data = [];
        let obj1 = {};
        list.forEach(item => {
          item.value = item.orderAmount;
          item.name = item.categoryName;
          obj1[item.categoryName] = item.orderAmount;
        });
        this.chart4Columns = list;
        this.chart4Data.push(obj1);
        this.chart4Data.forEach(obj => {
          for (const item in obj) {
            if (typeof obj[item] == 'number') {
              if (obj[item] > 10000) {
                obj[item] = (Math.round((obj[item] / 10000) * 100) / 100).toFixed(2) + 'w';
              } else {
                obj[item] = obj[item];
              }
            }
          }
        });
        this.echartsInit4(list);
      }
    },

    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    /* echartsInit1(xArr, yArr1, yArr2) {
      this.$nextTick(() => {
        this.myChart1 = this.$echarts.init(document.getElementById('myChart-1'));
        this.myChart1.setOption({
          title: {
            text: '销售趋势',
            textStyle: {
              fontSize: 14,
            },
            padding: [20, 0, 0, 20],
          },
          legend: {
            data: ['销售金额', '订单数'],
            top: 'bottom',
          },
          tooltip: {},
          xAxis: {
            data: xArr,
          },
          //直角坐标系内绘图网格
          grid: {
            top: '30%', //grid组件距上下左右的距离
            left: '3%',
            right: '3%',
            bottom: '10%',
            containLabel: true, //grid区域是否包含坐标轴的刻度标签。
          },

          yAxis: [
            {
              type: 'value',
              name: '销售金额',
              minInterval: 1,
              axisLabel: {
                formatter: function(value, index) {
                  if (value > 10000) {
                    value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
                  }
                  return value;
                },
              },
              splitNumber: 5,
              // interval: interval1,
            },
            {
              type: 'value',
              name: '订单数',
              minInterval: 1,
              axisLabel: {
                formatter: function(value, index) {
                  return value.toFixed(0);
                },
              },
              splitNumber: 5,
              // interval: interval2,
            },
          ],
          series: [
            {
              name: '销售金额',
              type: 'bar',
              data: yArr1,
              yAxisIndex: 0,
              barWidth: 18, //柱图宽度
              itemStyle: {
                color: '#6AA1FF',
              },
            },
            {
              name: '订单数',
              itemStyle: {
                color: '#FAAC7B',
              },
              type: 'line',
              smooth: true,
              data: yArr2,
              yAxisIndex: 1,
            },
          ],
        });
        this.resize(this.myChart1);
      });
    }, */
    echartsInit2(yData, barData) {
      this.$nextTick(() => {
        let myChart2 = this.$echarts.init(document.getElementById('myChart-2'));
        myChart2.setOption({
          title: {
            text: '销售金额排行TOP10 (BU)',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [20, 0, 0, 20],
          },
          tooltip: {},
          grid: {
            top: '15%', //grid组件距上下左右的距离
            left: '0%',
            right: '6%',
            bottom: '3%',
            containLabel: true, //grid区域是否包含坐标轴的刻度标签。
          },
          legend: {},
          xAxis: {
            axisLabel: {
              formatter: function(value, index) {
                if (value > 10000) {
                  value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
                }
                return value;
              },
            },
          },
          yAxis: {
            data: yData,
            axisLabel: {
              rotate: 38,
              formatter: function(value, index) {
                if (value.length > 6) {
                  value = value.substr(0, 4) + '...';
                }
                return value;
              },
            },
          },
          series: [
            {
              type: 'bar',
              data: barData,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#28B2FF' },
                  { offset: 1, color: '#32DAFF' },
                ]),
              },
            },
          ],
        });
        this.resize(myChart2);
      });
    },
    //销售金额排行  供应商
    echartsInit3(yData, barData) {
      this.$nextTick(() => {
        let myChart3 = this.$echarts.init(document.getElementById('myChart-3'));
        myChart3.setOption({
          title: {
            text: '销售金额排行TOP10 (供应商)',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [20, 0, 0, 20],
          },
          tooltip: {},
          grid: {
            top: '15%', //grid组件距上下左右的距离
            left: '0%',
            right: '6%',
            bottom: '3%',
            containLabel: true, //grid区域是否包含坐标轴的刻度标签。
          },
          legend: {},
          xAxis: {
            axisLabel: {
              formatter: function(value, index) {
                if (value > 10000) {
                  value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
                }
                return value;
              },
            },
          },
          yAxis: {
            data: yData,
            axisLabel: {
              rotate: 38,
              formatter: function(value, index) {
                if (value.length > 6) {
                  value = value.substr(0, 4) + '...';
                }
                return value;
              },
            },
          },
          series: [
            {
              type: 'bar',
              data: barData,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#28B2FF' },
                  { offset: 1, color: '#32DAFF' },
                ]),
              },
            },
          ],
        });
        this.resize(myChart3);
      });
    },
    echartsInit4(data) {
      this.$nextTick(() => {
        let myChart4 = this.$echarts.init(document.getElementById('myChart-4'));
        myChart4.setOption({
          title: {
            text: '物资大类分布',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [20, 0, 0, 20],
          },
          tooltip: {},
          legend: {
            top: 'bottom',
            icon: 'circle',
          },
          series: [
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['40%', '50%'],
              data: data,
            },
          ],
        });
        this.resize(myChart4);
      });
    },
    resize(chart) {
      window.addEventListener('resize', function() {
        chart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
::v-deep .el-table {
  .cell {
    overflow: visible;
    box-sizing: border-box;
    white-space: nowrap;
    word-break: normal;
    line-height: 23px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.title {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  height: 44px;
  padding: 0 20px;
  color: #333;
  .text {
    margin-left: 10px;
  }
  .more {
    color: #333;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal;
    &:hover {
      color: #0064c8;
    }
  }
}
.data-board-s {
  width: 100%;
  margin-top: 20px;
  .data-header-box {
    display: flex;
    height: 132px;
    background: #fff;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }
  .data-header-li {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-right: 1px solid #d9d9d9;
    &:last-child {
      border: 0;
    }

    .data-li-top {
      width: 100%;
      line-height: 1;
      color: #333;
      font-size: 14px;
    }
    .data-li-content {
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: space-between;
      .li-text {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: end;
        .text-h2 {
          color: #333;
          margin-bottom: 8px;
          .number {
            font-size: 30px;
          }
          span {
            font-size: 12px;
          }
        }
        .text-p {
          display: flex;
          align-items: center;
          color: #999;
          font-size: 12px;
          line-height: 1;
          & > div {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .data-header-li:nth-of-type(1) {
    width: 40%;
  }
  .data-header-li:nth-of-type(2) {
    width: 40%;
  }
  .data-header-li:nth-of-type(3) {
    width: 20%;
  }
  .databoard {
    .databoard_header {
      padding: 0 20px;
      height: 44px;
      background: #f5f5f5;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      .date {
        cursor: pointer;
        align-items: center;
        img {
          margin-right: 5px;
        }
        i {
          margin-left: 4px;
        }
      }
      .title {
        font-size: 14px;
        display: flex;
        align-items: center;
        background: #f5f5f5;
        color: #333;
        .icon {
          width: 18px;
          height: 18px;
          background: url('~@/assets/img/home/workbench/我要服务.png') no-repeat;
          background-size: 18px 18px;
          margin-right: 10px;
        }
      }
    }
    .table {
      padding: 20px;
      // border-bottom: 1px solid #d9d9d9;
    }
  }
}
#myChart-1 {
  width: 100%;
  height: 286px;
}
#myChart-2 {
  width: 270px;
  height: 286px;
}
#myChart-3 {
  width: 360px;
  height: 320px;
}
#myChart-4 {
  width: 360px;
  height: 320px;
}
.chart1 {
  /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); */
  background: #ffffff;
  position: relative;
  ::v-deep .el-popover__reference-wrapper {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 12px;
    color: #333;
    z-index: 1;
    cursor: pointer;
  }
  .chart2_btn {
    position: absolute;
    left: 466px;
    top: 14px;
    background: #f5f5f5;
    border-radius: 1px;
    width: 116px;
    height: 24px;
    padding: 3px;
    z-index: 999;
    p {
      flex: 0 0 50%;
      text-align: center;
      line-height: 18px;
      color: #666666;
      font-size: 12px;
      cursor: pointer;
    }
    .active {
      color: $main-col;
      background: #fff;
    }
  }
}
.charts_list {
  display: flex;
  justify-content: space-between;
  height: 462px;
  margin-top: 10px;
  .chart2 {
    background: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 270px;
    height: 100%;
    position: relative;
  }

  .chart2_table {
    display: flex;
    flex-wrap: wrap;
    margin: 0px 10px;
    max-height: 130px;
    overflow-y: auto;
    .chart2_table_item {
      width: 33.333333%;

      border-right: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
      border-top: 1px solid #dcdcdc;
      p {
        height: 40px;
        line-height: 40px;
        color: #333333;
        font-size: 14px;
        text-align: center;
        border-bottom: 1px solid #dcdcdc;
      }
      .name {
        background: #f5f5f5;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .item3 {
      border-right: none;
    }
  }
  .chart3 {
    background: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 360px;
    height: 100%;
  }
  .chart4 {
    background: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 360px;
    height: 100%;
  }
}
.datepicker {
  ::v-deep .el-range-separator {
    width: 30px !important;
  }
}

/*修改滚动条样式*/
.scrollbar_content_none {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar_content_none::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/*修改滚动条样式*/
.scrollbar_content {
  overflow-y: auto;
  -ms-overflow-style: none;
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 2px;
  }
  ::v-deep .el-table__fixed-right {
    height: 100% !important;
  }
  ::v-deep .el-table__fixed {
    height: 100% !important;
  }
}

.empty {
  height: 462px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .text {
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
  }
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #d9d9d9;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #999;
}
</style>
